import ky from "ky"
import { useAuthStore } from "@/stores/auth-store"
import { resolveApiUrl } from "@/lib/api/client"
import { expireSession } from "@/lib/auth/session"

let isRefreshing = false
let refreshPromise: Promise<boolean> | null = null

export async function tryRefreshToken(): Promise<boolean> {
  if (isRefreshing && refreshPromise) return refreshPromise

  isRefreshing = true
  refreshPromise = (async () => {
    const refreshToken = useAuthStore.getState().refreshToken
    if (!refreshToken) {
      // No refresh token means we never had a session (e.g. the login screen's
      // own failed request). Don't expire/redirect here — only an *attempted*
      // refresh that fails is a decisive "session over" signal.
      isRefreshing = false
      refreshPromise = null
      return false
    }

    try {
      const response = await ky
        .post(`${resolveApiUrl("auth-api")}/api/users/token/refresh/`, {
          json: { refresh: refreshToken },
        })
        .json<{ access: string }>()

      useAuthStore.getState().setTokens(response.access, refreshToken)
      return true
    } catch {
      expireSession()
      return false
    } finally {
      isRefreshing = false
      refreshPromise = null
    }
  })()

  return refreshPromise
}
